<template>
  <div>
    <b-modal
      id="publish-template-modal"
      ref="templatePublishModalRef"
      title="Publish Template To Zones"
      ok-title="Publish"
      :ok-disabled="showLoading"
      size="lg"
      no-close-on-backdrop
      @ok.prevent="handlePublish"
      @hidden="resetModal"
    >
      <b-overlay
        rounded="sm"
        no-fade
      >
        <validation-observer ref="templatePublishFormRef">
          <b-form
            class="p-2"
            @submit.prevent="handlePublish"
          >
            <b-row
              class="mb-1"
            >
              <b-col md="12">
                <b-form-group
                  label="Template"
                >
                  <b-form-input
                    :value="selectedTemplate.name"
                    readonly
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group>
              <b-row
                v-for="(services, zone) in servicesByZone"
                :key="'key_' + zone"
                class="mb-1"
              >
                <b-col
                  v-if="services.length > 0"
                  md="4"
                >
                  <span>{{ zone }}</span>
                </b-col>
                <b-col
                  v-if="services.length > 0"
                  md="8"
                >
                  <v-select
                    v-model="publishData.zone_services[zone]"
                    :options="services"
                    required
                    multiple
                  />
                </b-col>
              </b-row>

            </b-form-group>
          </b-form>
        </validation-observer>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, VBModal, BForm, BOverlay, BFormGroup, BFormInput, BRow, BCol,
} from 'bootstrap-vue'

import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BOverlay,
    vSelect,
    BFormInput,
    BRow,
    BCol,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    selectedTemplate: {
      type: Object,
      default: () => {},
    },
    servicesByZone: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const publishData = ref({
      zone_services: {},
    })
    const showLoading = ref(false)
    const templatePublishModalRef = ref(null)
    const templatePublishFormRef = ref(null)

    const doPublish = async () => {
      showLoading.value = true
      try {
        publishData.value.template_id = props.selectedTemplate.id
        publishData.value.template_name = props.selectedTemplate.name
        await store.dispatch('templates/publishTemplate', publishData.value)
        successNotification('Template Published successfully!')
        templatePublishModalRef.value.hide()
      } catch (error) {
        console.error(error)
        const message = error?.response?.data?.error?.detail?.message
        errorNotification(message || 'Failed')
      }
      showLoading.value = false
    }

    const handlePublish = async () => {
      if (showLoading.value) return // request already sent, block second submit
      const valid = await templatePublishFormRef.value.validate()
      let selectedServicesValid = false
      Object.keys(publishData.value.zone_services).forEach(key => {
        console.log(key, publishData.value.zone_services[key])
        if (publishData.value.zone_services[key] && publishData.value.zone_services[key].length > 0) {
          selectedServicesValid = true
        }
      })
      if (!selectedServicesValid) {
        errorNotification('Please select at least one service')
        return
      }
      if (valid) {
        await doPublish()
      }
    }

    const resetModal = async () => {
      publishData.value = {
        zone_services: {},
      }
    }

    return {
      publishData,
      showLoading,
      templatePublishFormRef,
      templatePublishModalRef,
      handlePublish,
      resetModal,
      required,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
